import React from 'react';
import InputField, {InputFieldProps} from "./InputField";

// Component ----

export type NumberFieldProps = Omit<InputFieldProps, 'type'>

function NumberField(props: NumberFieldProps) {
    return <InputField type="number" {...props} />
}

export default NumberField;